import React, { useContext, useEffect, useRef, useState } from "react";

import { NavigationContext } from "@components/TransitionRoot/NavigationContext";
import { getMediaUrl, setRecordCallBack, useUrl } from "@utils/navigation";
import { AudioPlayerEnabled, LitePlace, LocationType } from "@utils/data";
import PlaceHeader from "@components/PlaceHeader";

import { setAudioSettingChangeCallback, useCurrentSettings } from "@components/PersistedData/settingsSlice";
import { InteractivityState, getAudioContext, getInteractivityState } from "@utils/interactivity";
import { killAmbiance, startAmbiance } from "@utils/ambiance";
import { PlaceNavigationProps } from "./index.interface";

const LOOP_TIME_START = 4;
const LOOP_TIME_END = 13;

const getId = (container: HTMLElement) => {
  // @ts-ignore
  return container ? container?.id || getId(container.parentNode) : null;
};

const PlaceNavigation = ({ items }: PlaceNavigationProps) => {
  const { goto, setEnableAnecdote } = useContext(NavigationContext);

  const [targetPlace, setTargetPlace] = useState<string | null>(null);
  const settings = useCurrentSettings();
  const target: LitePlace | null = items.find((p: LitePlace) => {
    return p.id === targetPlace;
  });
  const videoRef = useRef();
  const video: HTMLVideoElement | null = videoRef?.current;
  const loopStart = target ? target.transition[0] : 0;
  const loopEnd = target ? target.transition[1] : LOOP_TIME_END;
  const targetUrl = useUrl({ type: "place", id: targetPlace });
  const enableAudio = getInteractivityState() === InteractivityState.SUCCES && settings.soundEnabled;

  useEffect(() => {
    if (enableAudio) {
      startAmbiance("ambiances/ambiance-accueil-v1.mp3");
      setRecordCallBack(({ type, id }) => {
        if (type === "cinematic" || type === "place") {
          killAmbiance();
        }
      });
      setAudioSettingChangeCallback(() => {
        killAmbiance();
      });
    }
    if (!settings.soundEnabled) {
      killAmbiance();
    }
  }, [enableAudio, settings.soundEnabled]);

  useEffect(() => {
    if (video) {
      video.currentTime = loopStart;
    }
  }, [loopStart, video]);

  const handleTimeUpdate = (e) => {
    const v = e.target;
    if (v && v.currentTime > loopEnd) {
      if (targetPlace) {
        const b = document.querySelector("body");
        b.classList.remove("transitionVideo");
        goto(targetUrl);
      } else {
        v.currentTime = LOOP_TIME_START;
      }
    }
  };

  const isAmbianceActive = () => {
    const wrapAmbianceBtn = document.querySelector("div.wrapBtnSound");
    return !wrapAmbianceBtn.classList.contains("soundInactive");
  };

  const playSound = async (soundUrl) => {
    if (isAmbianceActive()) {
      const sndUrl = getMediaUrl(soundUrl);
      const r = await fetch(sndUrl, {
        mode: "cors"
      });
      const b = await r.arrayBuffer();
      const context = getAudioContext();
      const buffer = await context.decodeAudioData(b);
      const source = context.createBufferSource();
      source.buffer = buffer;
      source.loop = false;
      source.connect(context.destination);
      source.start(0);
    }
  };

  const handleGotoPiece = (t: LocationType, id: string) => {
    if (t === "place") {
      setEnableAnecdote(AudioPlayerEnabled.Hidden);
      setTargetPlace(id);
      playSound("sfx/deplacement-v2.mp3");
      const b = document.querySelector("body");
      b.classList.add("transitionVideo");
    }
  };

  return (
    <>
      <div className="bg-video maison">
        <video
          id="bg-video-carte"
          ref={videoRef}
          src={getMediaUrl("transitions/exterieur-v2.mp4")}
          crossOrigin="anonymous"
          muted
          autoPlay
          playsInline
          webkit-playsinline="true"
          onTimeUpdate={handleTimeUpdate}
        />
      </div>
      <main className={`type-place carte ${targetPlace ? "transition" : ""}`}>
        <PlaceHeader onLinkClick={handleGotoPiece} />
      </main>
    </>
  );
};

export default PlaceNavigation;
